var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrainhealthindex(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 107,
    viewBox: "0 0 146 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5403_3552)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M142.117 96.6021C138.907 99.4556 134.34 100.637 129.922 101.383L129.179 101.504C124.565 102.241 119.9 102.634 115.219 102.873C112.715 103.003 110.21 103.095 107.706 103.177L105.743 103.239C103.195 103.32 100.641 103.399 98.0832 103.477C95.5787 103.554 93.0742 103.625 90.5696 103.692C87.3621 103.776 84.1545 103.846 80.9469 103.901C78.4424 103.944 75.9379 103.973 73.4333 103.989C70.2249 104.009 67.0173 104.002 63.8107 103.969C61.3044 103.942 58.7998 103.895 56.2971 103.828C53.0877 103.739 49.8802 103.61 46.6744 103.439C44.4985 103.325 42.324 103.188 40.1507 103.028L39.1608 102.953C29.8321 102.233 20.3359 100.94 12.1725 96.8549L11.9523 96.7433C11.8429 96.6882 11.7335 96.6331 11.6241 96.5752C10.1252 95.8072 8.68949 94.9051 7.33214 93.8784C4.91856 92.0335 2.92548 89.7817 1.87226 87.1104C0.221901 82.9204 1.09454 78.2106 2.97953 74.1139C4.86452 70.0172 7.69464 66.3188 10.1425 62.4608C10.8596 61.3307 11.5398 60.1582 12.1725 58.956C16.127 51.4166 18.0884 42.692 13.9428 35.4267C13.3956 34.5004 12.8047 33.6045 12.1725 32.7426C11.1614 31.33 10.1333 29.9173 9.43858 28.3535C7.81855 24.7145 8.16654 20.622 8.75709 16.7343C9.54799 11.5654 10.998 5.9981 15.5299 2.76875C20.2318 -0.584907 26.9057 -0.415387 32.7413 0.791027C41.8143 2.65433 50.1886 6.55469 58.6421 10.0722C67.0956 13.5898 75.9511 16.8064 85.2455 17.1525C87.2421 17.2257 89.241 17.1478 91.2274 16.9194C93.8754 16.6278 96.4875 16.0383 99.0204 15.1606C102.678 13.8695 106.007 11.927 108.474 9.22745C113.767 3.45672 123.712 3.02021 130.883 6.50525C137.726 9.83066 142.151 16.8685 141.824 23.898C141.452 31.7227 135.985 38.156 130.974 44.7545C130.367 45.5541 129.767 46.3565 129.183 47.1645C128.857 47.6156 128.537 48.0677 128.223 48.5207C127.674 49.3202 127.142 50.124 126.641 50.9377C124.082 55.1093 122.272 60.12 124.034 64.6236C125.023 67.1452 126.909 69.0693 129.183 70.7489C134.278 74.5108 141.31 77.0423 144.474 82.3087C147.2 86.8476 146.19 92.9743 142.117 96.6021Z",
    fill: "#039BE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 51C9.31371 51 12 48.3137 12 45C12 41.6863 9.31371 39 6 39C2.68629 39 0 41.6863 0 45C0 48.3137 2.68629 51 6 51Z",
    fill: "#E6F5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5 12C96.433 12 98 10.433 98 8.5C98 6.567 96.433 5 94.5 5C92.567 5 91 6.567 91 8.5C91 10.433 92.567 12 94.5 12Z",
    fill: "#E6F5FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6582 40.4331L72.5643 45.579C73.5516 46.6145 74.1063 48.019 74.1063 49.4836L74.1063 82.8877",
    stroke: "#7B7979",
    strokeWidth: 0.375744,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3339 70.3004L71.4213 74.5877C73.1404 76.3909 74.1062 78.8366 74.1062 81.3867L74.1062 89.7756",
    stroke: "#7B7979",
    strokeWidth: 0.375744,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3105 57.062L76.7829 60.7623C75.0638 62.5655 74.0981 65.0112 74.0981 67.5612L74.0981 75.9502",
    stroke: "#7B7979",
    strokeWidth: 0.375744,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3105 80.4888L76.7829 84.1891C75.0639 85.9923 74.0981 88.4379 74.0981 90.988L74.0981 94.8094",
    stroke: "#7B7979",
    strokeWidth: 0.375744,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6227 37.4061C82.6227 46.9155 74.9142 54.6243 65.4053 54.6243C55.8964 54.6243 48.1879 46.9155 48.1879 37.4061C48.1879 27.8967 55.8964 20.1879 65.4053 20.1879C74.9142 20.1879 82.6227 27.8967 82.6227 37.4061Z",
    fill: "#D81159",
    fillOpacity: 0.3,
    stroke: "#D81159",
    strokeWidth: 0.375744
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.3057,
    y: 35.0078,
    width: 4.1992,
    height: 4.79663,
    rx: 0.375744,
    fill: "#D81159"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.989 52.8474C96.989 60.5663 90.7312 66.8238 83.0118 66.8238C75.2924 66.8238 69.0346 60.5663 69.0346 52.8474C69.0346 45.1284 75.2924 38.871 83.0118 38.871C90.7312 38.871 96.989 45.1284 96.989 52.8474Z",
    fill: "#27856E",
    fillOpacity: 0.3,
    stroke: "#27856E",
    strokeWidth: 0.375744
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6855 51.1839C82.8301 50.9335 83.1917 50.9335 83.3363 51.1839L85.5044 54.939C85.6491 55.1895 85.4683 55.5026 85.179 55.5026H80.8428C80.5535 55.5026 80.3727 55.1895 80.5174 54.939L82.6855 51.1839Z",
    fill: "#27856E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6239 67.4571C78.6239 74.8545 72.6269 80.8513 65.2291 80.8513C57.8314 80.8513 51.8344 74.8545 51.8344 67.4571C51.8344 60.0597 57.8314 54.0629 65.2291 54.0629C72.6269 54.0629 78.6239 60.0597 78.6239 67.4571Z",
    fill: "#7B1FA2",
    fillOpacity: 0.3,
    stroke: "#7B1FA2",
    strokeWidth: 0.375744
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8717 65.4736C64.9842 65.1274 65.4739 65.1274 65.5864 65.4735L65.9139 66.4816C65.9642 66.6364 66.1085 66.7412 66.2713 66.7412L67.3312 66.7412C67.6952 66.7412 67.8465 67.207 67.5521 67.4209L66.6946 68.0439C66.5629 68.1396 66.5078 68.3092 66.5581 68.464L66.8856 69.472C66.9981 69.8181 66.6019 70.106 66.3074 69.8921L65.4499 69.2691C65.3182 69.1734 65.1399 69.1734 65.0082 69.2691L64.1507 69.8921C63.8562 70.106 63.46 69.8181 63.5725 69.472L63.9 68.464C63.9503 68.3092 63.8952 68.1396 63.7635 68.0439L62.906 67.4209C62.6116 67.207 62.7629 66.7412 63.1269 66.7412L64.1868 66.7412C64.3496 66.7412 64.4938 66.6364 64.5442 66.4816L64.8717 65.4736Z",
    fill: "#7B1FA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5039 77.6116C91.5039 82.1453 87.8289 85.8206 83.2956 85.8206C78.7623 85.8206 75.0873 82.1453 75.0873 77.6116C75.0873 73.078 78.7623 69.4027 83.2956 69.4027C87.8289 69.4027 91.5039 73.078 91.5039 77.6116Z",
    fill: "#FBB13C",
    fillOpacity: 0.3,
    stroke: "#FBB13C",
    strokeWidth: 0.375744
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0441 78.7369C81.6344 78.7369 83.2945 78.7369 83.2945 78.7369C83.2945 78.7369 84.0046 78.7369 85.5449 78.7369C85.5449 77.4939 84.5374 76.4863 83.2945 76.4863C82.0517 76.4863 81.0441 77.4939 81.0441 78.7369Z",
    fill: "#FBB13C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6582 40.4331L72.5643 45.579C73.5516 46.6145 74.1063 48.019 74.1063 49.4836L74.1063 82.8877",
    stroke: "#7B7979",
    strokeWidth: 0.375744,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3339 70.3004L71.4213 74.5877C73.1404 76.3909 74.1062 78.8366 74.1062 81.3867L74.1062 89.7756",
    stroke: "#7B7979",
    strokeWidth: 0.375744,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3105 57.062L76.7829 60.7623C75.0638 62.5655 74.0981 65.0112 74.0981 67.5612L74.0981 75.9502",
    stroke: "#7B7979",
    strokeWidth: 0.375744,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3105 80.4888L76.7829 84.1891C75.0639 85.9923 74.0981 88.4379 74.0981 90.988L74.0981 94.8094",
    stroke: "#7B7979",
    strokeWidth: 0.375744,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6227 37.4061C82.6227 46.9155 74.9142 54.6243 65.4053 54.6243C55.8964 54.6243 48.1879 46.9155 48.1879 37.4061C48.1879 27.8967 55.8964 20.1879 65.4053 20.1879C74.9142 20.1879 82.6227 27.8967 82.6227 37.4061Z",
    fill: "#D81159",
    fillOpacity: 0.3,
    stroke: "#D81159",
    strokeWidth: 0.375744
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.3057,
    y: 35.0078,
    width: 4.1992,
    height: 4.79663,
    rx: 0.375744,
    fill: "#D81159"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.989 52.8474C96.989 60.5663 90.7312 66.8238 83.0118 66.8238C75.2924 66.8238 69.0346 60.5663 69.0346 52.8474C69.0346 45.1284 75.2924 38.871 83.0118 38.871C90.7312 38.871 96.989 45.1284 96.989 52.8474Z",
    fill: "#27856E",
    fillOpacity: 0.3,
    stroke: "#27856E",
    strokeWidth: 0.375744
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6855 51.1839C82.8301 50.9335 83.1917 50.9335 83.3363 51.1839L85.5044 54.939C85.6491 55.1895 85.4683 55.5026 85.179 55.5026H80.8428C80.5535 55.5026 80.3727 55.1895 80.5174 54.939L82.6855 51.1839Z",
    fill: "#27856E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6239 67.4571C78.6239 74.8545 72.6269 80.8513 65.2291 80.8513C57.8314 80.8513 51.8344 74.8545 51.8344 67.4571C51.8344 60.0597 57.8314 54.0629 65.2291 54.0629C72.6269 54.0629 78.6239 60.0597 78.6239 67.4571Z",
    fill: "#7B1FA2",
    fillOpacity: 0.3,
    stroke: "#7B1FA2",
    strokeWidth: 0.375744
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8717 65.4736C64.9842 65.1274 65.4739 65.1274 65.5864 65.4735L65.9139 66.4816C65.9642 66.6364 66.1085 66.7412 66.2713 66.7412L67.3312 66.7412C67.6952 66.7412 67.8465 67.207 67.5521 67.4209L66.6946 68.0439C66.5629 68.1396 66.5078 68.3092 66.5581 68.464L66.8856 69.472C66.9981 69.8181 66.6019 70.106 66.3074 69.8921L65.4499 69.2691C65.3182 69.1734 65.1399 69.1734 65.0082 69.2691L64.1507 69.8921C63.8562 70.106 63.46 69.8181 63.5725 69.472L63.9 68.464C63.9503 68.3092 63.8952 68.1396 63.7635 68.0439L62.906 67.4209C62.6116 67.207 62.7629 66.7412 63.1269 66.7412L64.1868 66.7412C64.3496 66.7412 64.4938 66.6364 64.5442 66.4816L64.8717 65.4736Z",
    fill: "#7B1FA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5039 77.6116C91.5039 82.1453 87.8289 85.8206 83.2956 85.8206C78.7623 85.8206 75.0873 82.1453 75.0873 77.6116C75.0873 73.078 78.7623 69.4027 83.2956 69.4027C87.8289 69.4027 91.5039 73.078 91.5039 77.6116Z",
    fill: "#FBB13C",
    fillOpacity: 0.3,
    stroke: "#FBB13C",
    strokeWidth: 0.375744
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0441 78.7369C81.6344 78.7369 83.2945 78.7369 83.2945 78.7369C83.2945 78.7369 84.0046 78.7369 85.5449 78.7369C85.5449 77.4939 84.5374 76.4863 83.2945 76.4863C82.0517 76.4863 81.0441 77.4939 81.0441 78.7369Z",
    fill: "#FBB13C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5403_3552"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 146,
    height: 107,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrainhealthindex);
export default __webpack_public_path__ + "static/media/brainhealthindex.f2a74d51.svg";
export { ForwardRef as ReactComponent };